import { createContext, useState, useEffect } from "react";

const SimpleContext = createContext();

export default SimpleContext;

export const SimpleProvider = ({ children }) => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showVerification, setShowVerification] = useState(false);

  const showLoginPopup = () => {
    setShowLogin(true);
    setShowRegister(false);
    window.history.pushState(null, "", "?popup=login");
  };
  const showRegisterPopup = () => {
    setShowLogin(false);
    setShowRegister(true);
    window.history.pushState(null, "", "?popup=register");
  };
  const closeLoginPopup = () => {
    setShowLogin(false);
    const url = new URL(window.location);
    url.searchParams.delete("popup");
    window.history.replaceState(null, "", url.toString());
  };
  const closeRegisterPopup = () => {
    setShowRegister(false);
    const url = new URL(window.location);
    url.searchParams.delete("popup");
    window.history.replaceState(null, "", url.toString());
  };
  let values = {
    showLogin,
    showRegister,
    showLoginPopup,
    showVerification,
    setShowVerification,
    showRegisterPopup,
    closeLoginPopup,
    closeRegisterPopup,
  };

  return (
    <SimpleContext.Provider value={values}>{children}</SimpleContext.Provider>
  );
};
